// extracted by mini-css-extract-plugin
export default {"Modal":"ReportContentDialog_Modal__RdoJ3","Success":"ReportContentDialog_Success__w2BKB"};